import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import user from './user';
import license from './license';
import admin from './admin';
import notification from './notification';

const reducers = history =>
  combineReducers({
    router: connectRouter(history),
    user,
    license,
    admin,
    notification
  });

export default reducers;
